import { useSnackbar } from 'notistack';
import { Button, CircularProgress } from '@mui/material';
import { orange } from '@mui/material/colors';
import { COMMON_STRING, SUCCESS_STRING } from '@/constants/dictionary';
import { SnackbarCloseActionProps } from '@/components/SnackbarActions/SnackbarCloseAction';
import {
  ActionOf,
  AddFixtureActionMsg,
  SCORING_WORKER_HOST_ACTION,
} from '@/workers/scoring/types';
import { FIXTURE_ACTION_TYPE } from '@/service/constants';
import { UseDispatchWithResponse } from '@/contexts/scoring/createUseDispatchWithResponse';
import { ScoringState } from '@/contexts/scoring/types';

interface SnackbarNoVarActionProps extends SnackbarCloseActionProps {
  fixtureId: ScoringState['fixtureId'];
  useDispatchWithResponse: <T>(
    action: ActionOf<T>
  ) => UseDispatchWithResponse<T>;
}

export const SnackbarNoVarAction = ({
  snackbarId,
  fixtureId,
  useDispatchWithResponse,
}: SnackbarNoVarActionProps) => {
  const { closeSnackbar } = useSnackbar();

  const { dispatch: addAction, isLoading } =
    useDispatchWithResponse<AddFixtureActionMsg>(
      SCORING_WORKER_HOST_ACTION.ADD_FIXTURE_ACTION
    );

  const submitNoVarAction = async () =>
    addAction(
      {
        fixtureId,
        fixtureActionTypeId: FIXTURE_ACTION_TYPE.NO_VIDEO_CHECK,
        withLastFixtureActionParams: true,
      },
      {
        successMessage: SUCCESS_STRING.ACTION_SUCCESSFULLY_ADDED,
      }
    )
      .catch(() => closeSnackbar(snackbarId))
      .then(() => closeSnackbar(snackbarId));

  return (
    <Button
      disabled={isLoading}
      variant='text'
      startIcon={
        isLoading && <CircularProgress color={'inherit'} size={'1em'} />
      }
      onClick={submitNoVarAction}
      sx={{ color: orange[100] }}
    >
      {COMMON_STRING.NO_VAR}
    </Button>
  );
};
